





























































































import { Component, Mixins } from "vue-property-decorator";
import Search from "@/components/elements/utility/Search.vue";
import DataTable from "@/components/elements/utility/Table.vue";
import { LineItem } from "@/models/order/order";
import { OrderStatus } from "@/models/order/helpers";
import { NetSuiteCustomer } from "@/models/netsuite/netsuite";
import ConfirmNewQuote from "@/components/elements/modal/ConfirmNewQuote.vue";
import { OrderMixin } from "@/mixins/orders/mixin";
import { CustomerMixin } from "@/mixins/customers/mixin";
import { Mobile } from "@/mixins/mobile";
import ConfirmClearAll from "@/components/elements/modal/ConfirmClearAll.vue";

@Component({
  components: {
    Search,
    DataTable,
    ConfirmNewQuote,
    ConfirmClearAll
  }
})
export default class CustomerOrders extends Mixins(
  Mobile,
  OrderMixin,
  CustomerMixin
) {
  protected orderStatus = OrderStatus;
  protected customer: NetSuiteCustomer = {} as NetSuiteCustomer;
  protected id = "";
  protected loader: any = null;
  protected showModalNew = false;

  async created() {
    this.showLoader("Obtaining Quotes...");
    if (this.$route.params.id) {
      this.id = this.$route.params.id as string;
      this.customer = await this.netSuiteService.getNetSuiteCustomerById(
        this.id
      );
      this.showLoader(`Obtaining ${this.customer.company_name} Quotes...`);
      await this.prepareNetSuiteQuotes();
      this.orders = this.netSuiteQuotes;
      this.closeLoader();
    } else {
      this.closeLoader();
      this.$router.replace("/customers");
    }
  }

  protected async prepareNetSuiteQuotes(): Promise<void> {
    const customerNetSuiteQuotes = await this.netSuiteService.getCustomerNetSuiteQuotes(
      parseInt(this.id)
    );
    // // ToDo: FNSI-101 - get the quote line items for each quote in the array.
    // const netSuiteQuotesWithLineItems = await this.getNetSuiteQuoteLineItems(
    //   customerNetSuiteQuotes
    // );
    // console.log(
    //   "decide what to do with netSuiteQuotesWithLineItems",
    //   netSuiteQuotesWithLineItems
    // );
    // this.convertNetSuiteQuotes(netSuiteQuotesWithLineItems);
    this.convertNetSuiteQuotes(customerNetSuiteQuotes);
  }

  protected closeModal(): void {
    this.showModalNew = false;
  }

  protected async clearOrder(): Promise<void> {
    await this.resetOrder();
    await this.reassignQuote();
  }

  protected toggleNewQuoteModal(): void {
    if (this.items.length > 0) {
      // only toggling warning modal if there is an item associated with the order
      this.showModalNew = true;
    } else {
      this.reassignQuote();
    }
  }

  protected async reassignQuote() {
    await this.saveCustomerToStore(
      this.customer.customer_id.toString(),
      this.customer.company_name,
      1 + (this.customer.price_level_discount ?? 0),
      this.customer.customer_id,
      this.customer.payment_terms_id || undefined,
      this.customer.price_level_id,
      this.customer.price_level_discount ?? undefined,
      null
    );
    this.close();
    this.$router.push("/");
  }

  protected getMultiplier(
    items: LineItem[],
    price_level_discount?: number
  ): number {
    if (price_level_discount !== undefined) {
      return parseFloat((1 + price_level_discount).toFixed(4));
    }
    if (items.length > 0 && items[0].multiplier) {
      return items[0].multiplier;
    }
    return 1;
  }

  protected showLoader(message = "Loading..."): void {
    if (this.loader) {
      this.loader.hide();
    }
    this.loader = this.$loading.show(
      { opacity: 1 },
      {
        before: this.$createElement("h1", message)
      }
    );
  }

  protected closeLoader(): void {
    setTimeout(() => {
      this.loader.hide();
    }, 300);
  }
}
